export enum EVehicleType {
  BIKE = "Bike",
  CAR = "Car",
}
